// source: livongo/protobuf/grpc/external/coaching/coaching.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.Values', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    parent: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string parent = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableRequest.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    preserve: (f = msg.getPreserve()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    priorityRank: (f = msg.getPriorityRank()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo;
  return proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setPreserve(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setPriorityRank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPreserve();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPriorityRank();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_uuid = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.BoolValue preserve = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.getPreserve = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.setPreserve = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.clearPreserve = function() {
  return this.setPreserve(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.hasPreserve = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value priority_rank = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.getPriorityRank = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.setPriorityRank = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.clearPriorityRank = function() {
  return this.setPriorityRank(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserReportableInfo.prototype.hasPriorityRank = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    parent: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string parent = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCRequest.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    latestPredictedUtc: (f = msg.getLatestPredictedUtc()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse;
  return proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLatestPredictedUtc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatestPredictedUtc();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp latest_predicted_utc = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.prototype.getLatestPredictedUtc = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.prototype.setLatestPredictedUtc = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.prototype.clearLatestPredictedUtc = function() {
  return this.setLatestPredictedUtc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetLatestPredictUTCResponse.prototype.hasLatestPredictedUtc = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    parent: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string parent = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachRequest.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    userUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    firstName: (f = msg.getFirstName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    lastName: (f = msg.getLastName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    firstTime: (f = msg.getFirstTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse;
  return proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFirstName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLastName(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setFirstTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getLastName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFirstTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_uuid = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue first_name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.getFirstName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.setFirstName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.clearFirstName = function() {
  return this.setFirstName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.hasFirstName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue last_name = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.getLastName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.setLastName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.clearLastName = function() {
  return this.setLastName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.hasLastName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue first_time = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.getFirstTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.setFirstTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.clearFirstTime = function() {
  return this.setFirstTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberAssignedCoachResponse.prototype.hasFirstTime = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    parent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    testOnlyFields: (f = msg.getTestOnlyFields()) && proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    case 100:
      var value = new proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.deserializeBinaryFromReader);
      msg.setTestOnlyFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTestOnlyFields();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstTime: (f = msg.getFirstTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields;
  return proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setFirstTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.BoolValue first_time = 1;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.prototype.getFirstTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 1));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.prototype.setFirstTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.prototype.clearFirstTime = function() {
  return this.setFirstTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields.prototype.hasFirstTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string parent = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TestOnlyFields test_only_fields = 100;
 * @return {?proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.prototype.getTestOnlyFields = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields, 100));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.TestOnlyFields|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.prototype.setTestOnlyFields = function(value) {
  return jspb.Message.setWrapperField(this, 100, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.prototype.clearTestOnlyFields = function() {
  return this.setTestOnlyFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedRequest.prototype.hasTestOnlyFields = function() {
  return jspb.Message.getField(this, 100) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstTime: (f = msg.getFirstTime()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse;
  return proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setFirstTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.BoolValue first_time = 1;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.prototype.getFirstTime = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 1));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.prototype.setFirstTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.prototype.clearFirstTime = function() {
  return this.setFirstTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MarkCoachViewedResponse.prototype.hasFirstTime = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetMemberUpcomingSessionRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionsList: jspb.Message.toObjectList(msg.getSessionsList(),
    proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse;
  return proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.deserializeBinaryFromReader);
      msg.addSessions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UpcomingCoachingSession sessions = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.prototype.getSessionsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.prototype.setSessionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession}
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.prototype.addSessions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.MemberUpcomingSessionsResponse.prototype.clearSessionsList = function() {
  return this.setSessionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.toObject = function(includeInstance, msg) {
  var f, obj = {
    memberUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    calendarId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    appointmentDateTimeutc: (f = msg.getAppointmentDateTimeutc()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    coachFullName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sessionType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    sessionMethod: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession;
  return proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberUuid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCalendarId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAppointmentDateTimeutc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoachFullName(value);
      break;
    case 5:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.Values} */ (reader.readEnum());
      msg.setSessionType(value);
      break;
    case 6:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.Values} */ (reader.readEnum());
      msg.setSessionMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCalendarId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAppointmentDateTimeutc();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCoachFullName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSessionType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSessionMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string member_uuid = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.getMemberUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.setMemberUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 calendar_id = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.getCalendarId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.setCalendarId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp appointment_date_timeUTC = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.getAppointmentDateTimeutc = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.setAppointmentDateTimeutc = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.clearAppointmentDateTimeutc = function() {
  return this.setAppointmentDateTimeutc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.hasAppointmentDateTimeutc = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string coach_full_name = 4;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.getCoachFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.setCoachFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional UserSessionType.Values session_type = 5;
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.Values}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.getSessionType = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.Values} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.setSessionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional UserSessionMethod.Values session_method = 6;
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.Values}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.getSessionMethod = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.Values} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpcomingCoachingSession.prototype.setSessionMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod;
  return proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionMethod.Values = {
  INVALID: 0,
  PHONE: 1,
  VIDEO: 2,
  OTHER: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType;
  return proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UserSessionType.Values = {
  INVALID: 0,
  INTRO: 1,
  FOLLOW_UP: 2,
  OTHER: 3,
  INITIAL_VISIT: 4
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    caseId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sessionTime: (f = msg.getSessionTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    topicsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary;
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaseId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSessionTime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addTopics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessionTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTopicsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional string case_id = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.getCaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp session_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.getSessionTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.setSessionTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.clearSessionTime = function() {
  return this.setSessionTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.hasSessionTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated string topics = 4;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.getTopicsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.setTopicsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.addTopics = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.prototype.clearTopicsList = function() {
  return this.setTopicsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    parent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timeZone: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string parent = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string time_zone = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsRequest.prototype.setTimeZone = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    summariesList: jspb.Message.toObjectList(msg.getSummariesList(),
    proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse;
  return proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.deserializeBinaryFromReader);
      msg.addSummaries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummariesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CoachingSessionSummary summaries = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.prototype.getSummariesList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.prototype.setSummariesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.prototype.addSummaries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListCoachingSessionsResponse.prototype.clearSummariesList = function() {
  return this.setSummariesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.toObject = function(includeInstance, msg) {
  var f, obj = {
    goalId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    caseId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    category: jspb.Message.getFieldWithDefault(msg, 3, ""),
    text: (f = msg.getText()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    statusDate: (f = msg.getStatusDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal;
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGoalId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaseId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setText(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStatusDate(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGoalId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaseId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getText();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatusDate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string goal_id = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.getGoalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.setGoalId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string case_id = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.getCaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string category = 3;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue text = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.getText = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.setText = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.clearText = function() {
  return this.setText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.hasText = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp status_date = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.getStatusDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.setStatusDate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.clearStatusDate = function() {
  return this.setStatusDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.hasStatusDate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp start_date = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    caseId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timeZone: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaseId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCaseId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string case_id = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.prototype.getCaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string time_zone = 3;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsRequest.prototype.setTimeZone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.repeatedFields_ = [7,8,9,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    caseId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sessionTime: (f = msg.getSessionTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    coachName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    statusTime: (f = msg.getStatusTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    topicsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    newGoalsList: jspb.Message.toObjectList(msg.getNewGoalsList(),
    proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.toObject, includeInstance),
    continuedGoalsList: jspb.Message.toObjectList(msg.getContinuedGoalsList(),
    proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.toObject, includeInstance),
    completedGoalsList: jspb.Message.toObjectList(msg.getCompletedGoalsList(),
    proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.toObject, includeInstance),
    resourcesMap: (f = msg.getResourcesMap()) ? f.toObject(includeInstance, undefined) : [],
    caseType: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse;
  return proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaseId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSessionTime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoachName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStatusTime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addTopics(value);
      break;
    case 8:
      var value = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.deserializeBinaryFromReader);
      msg.addNewGoals(value);
      break;
    case 9:
      var value = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.deserializeBinaryFromReader);
      msg.addContinuedGoals(value);
      break;
    case 10:
      var value = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.deserializeBinaryFromReader);
      msg.addCompletedGoals(value);
      break;
    case 11:
      var value = msg.getResourcesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaseType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessionTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCoachName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatusTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTopicsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getNewGoalsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.serializeBinaryToWriter
    );
  }
  f = message.getContinuedGoalsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.serializeBinaryToWriter
    );
  }
  f = message.getCompletedGoalsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.serializeBinaryToWriter
    );
  }
  f = message.getResourcesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCaseType();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string case_id = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getCaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp session_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getSessionTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setSessionTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.clearSessionTime = function() {
  return this.setSessionTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.hasSessionTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string coach_name = 4;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getCoachName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setCoachName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp status_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getStatusTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setStatusTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.clearStatusTime = function() {
  return this.setStatusTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.hasStatusTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated string topics = 7;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getTopicsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setTopicsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.addTopics = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.clearTopicsList = function() {
  return this.setTopicsList([]);
};


/**
 * repeated CoachingSessionGoal new_goals = 8;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getNewGoalsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, 8));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setNewGoalsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.addNewGoals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.clearNewGoalsList = function() {
  return this.setNewGoalsList([]);
};


/**
 * repeated CoachingSessionGoal continued_goals = 9;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getContinuedGoalsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, 9));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setContinuedGoalsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.addContinuedGoals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.clearContinuedGoalsList = function() {
  return this.setContinuedGoalsList([]);
};


/**
 * repeated CoachingSessionGoal completed_goals = 10;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getCompletedGoalsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, 10));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setCompletedGoalsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.addCompletedGoals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.clearCompletedGoalsList = function() {
  return this.setCompletedGoalsList([]);
};


/**
 * map<string, string> resources = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getResourcesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.clearResourcesMap = function() {
  this.getResourcesMap().clear();
  return this;
};


/**
 * optional string case_type = 12;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.getCaseType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingSessionDetailsResponse.prototype.setCaseType = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    parent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timeZone: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string parent = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string time_zone = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsRequest.prototype.setTimeZone = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    continuedGoalsList: jspb.Message.toObjectList(msg.getContinuedGoalsList(),
    proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.toObject, includeInstance),
    completedGoalsList: jspb.Message.toObjectList(msg.getCompletedGoalsList(),
    proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse;
  return proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.deserializeBinaryFromReader);
      msg.addContinuedGoals(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.deserializeBinaryFromReader);
      msg.addCompletedGoals(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContinuedGoalsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.serializeBinaryToWriter
    );
  }
  f = message.getCompletedGoalsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CoachingSessionGoal continued_goals = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.getContinuedGoalsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.setContinuedGoalsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.addContinuedGoals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.clearContinuedGoalsList = function() {
  return this.setContinuedGoalsList([]);
};


/**
 * repeated CoachingSessionGoal completed_goals = 2;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.getCompletedGoalsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, 2));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.setCompletedGoalsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal}
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.addCompletedGoals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.livongo.protobuf.grpc.external.coaching.CoachingSessionGoal, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.ListMemberGoalsResponse.prototype.clearCompletedGoalsList = function() {
  return this.setCompletedGoalsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus;
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values = {
  INVALID: 0,
  VIEWED: 1,
  SKIPPED: 2,
  COMPLETED: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName;
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values = {
  INVALID: 0,
  COACHING_ENGAGEMENT: 1
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    flowName: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values} */ (reader.readEnum());
      msg.setFlowName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFlowName();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CoachingFlowName.Values flow_name = 2;
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values}
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.prototype.getFlowName = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.GetCoachingFlowStatusRequest.prototype.setFlowName = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    flowName: jspb.Message.getFieldWithDefault(msg, 1, 0),
    flowStatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse;
  return proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values} */ (reader.readEnum());
      msg.setFlowName(value);
      break;
    case 2:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values} */ (reader.readEnum());
      msg.setFlowStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlowName();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getFlowStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional CoachingFlowName.Values flow_name = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.prototype.getFlowName = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.prototype.setFlowName = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional CoachingFlowStatus.Values flow_status = 2;
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values}
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.prototype.getFlowStatus = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatusResponse.prototype.setFlowStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    flowStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    flowName: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest;
  return proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values} */ (reader.readEnum());
      msg.setFlowStatus(value);
      break;
    case 3:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values} */ (reader.readEnum());
      msg.setFlowName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFlowStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFlowName();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CoachingFlowStatus.Values flow_status = 2;
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.prototype.getFlowStatus = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowStatus.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.prototype.setFlowStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional CoachingFlowName.Values flow_name = 3;
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values}
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.prototype.getFlowName = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.coaching.CoachingFlowName.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.coaching.UpdateCoachingFlowStatusRequest.prototype.setFlowName = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


goog.object.extend(exports, proto.com.livongo.protobuf.grpc.external.coaching);
